<template>
  <div class="column is-12">
    <div class="box">
      <div class="columns">
        <div class="column is-12">
          <strong>{{ elLabel }}</strong>

          <a class="icon is-info is-large is-pulled-right" @click="$emit('teamWasAdded')">
            <i class="fa fa-plus-circle fa-2x"></i>
          </a>

        </div>
      </div>

      <draggable v-model="n" :options="{draggable:'.mitarbeiter', handle:'.my-handle'}" class="columns is-multiline">
        <div class="column is-12 mitarbeiter" v-for="(i, index) in n" :key="i.id">
          <div class="box" style="background-color: #f9f9f9;">
            <div class="columns is-variable is-1 is-multiline">
              <div class="column is-12">

                <div class="field">

                                  <!-- move item -->
                <a class="is-pulled-right icon my-handle" style="margin-left:30px;">
                  <i class="fa fa-arrows"></i>
                </a>


                  <a class="is-pulled-right" @click="$emit('teamWasRemoved', index)">
                  Mitarbeiter löschen
                </a>
                          <img v-if="!i.image.length" src="../../../assets/img.png" style="max-width: 100px; max-height: 100px;"
                          @click="$emit('showImageSelector', { target: propName, child: index })">
                          <img v-else :src="assetsBaseUrl + i.image" style="width: 100px;"
                          @click="$emit('removeImage', { target: propName, child: index })">
                      </div>

                <!-- delete section -->

              </div>

              <div class="column is-6">
                <div class="field">
                  <div class="control has-icons-right">
                    <input 
                    maxlength="500"
                    placeholder="Name" 
                    :class="{'input': true, 'is-small': true, 'is-danger': errors.has('name' + index) }" 
                    type="text" 
                    v-validate="'required'" 
                    v-model="i.name"
                    :name="'name' + index">
                    <span v-show="errors.has('name' + index)" class="icon is-small is-right">
                      <i class="fa fa-warning"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="field">
                  <div class="control has-icons-right">
                    <input 
                    maxlength="500"
                    placeholder="Titel" 
                    :class="{'input': true, 'is-small': true, 'is-danger': errors.has('title' + index) }" 
                    type="text" 
                    v-validate="'required'" 
                    v-model="i.title"
                    :name="'title' + index">
                    <span v-show="errors.has('title' + index)" class="icon is-small is-right">
                      <i class="fa fa-warning"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column is-12">

                                    <div class="field">
                        <div class="control">
                          <p :class="{ 'control': true, 'has-icon': true, 'has-icon-right': true }">
                            <textarea 
                            maxlength="5000"  
                            rows="4" 
                            v-model="i.text"
                            v-validate="'required'" 
                            :class="{'textarea': true, 'is-small': true, 'is-danger': errors.has('ct' + index) }" 
                            :name="'ct' + index" 
                            :id="'ct' + index" 
                            placeholder="Text"></textarea>
                            <span v-show="errors.has('ct' + index)" class="icon is-small"><i class="fa fa-warning"></i></span>
                          </p>
                        </div>
                      </div>
</div>


              <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="Webseite" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.globe">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="LinkedIn" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.linkedin">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="Xing" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.xing">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="Twitter" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.twitter">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="Facebook" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.facebook">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="G+" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.google">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="Instagram" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.instagram">
                  </div>
                </div>
              </div>

                            <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="YouTube" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.youtube">
                  </div>
                </div>
              </div>

                      <div class="column is-3">
                <div class="field">
                  <div class="control">
                    <input 
                    maxlength="500"
                    placeholder="E-mail" 
                    class="input is-small"
                    type="text" 
                    v-model="i.social.envelope">
                  </div>
                </div>
              </div>

              <div class="column is-12">
                <span v-if="i.download.length">{{ i.download }} <a @click="$emit('removeDownload', { target: 'download', child: index })">Löschen</a></span>
                <a @click="$emit('showImageSelector', { target: 'download', child: index })" v-else>Lebenslauf als Download hinzufügen</a>
              </div>




            </div>

          </div>
        </div>
      </draggable>


    </div>


  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  inject: ['$validator'],
  props: ['data', 'elLabel', 'propName'],
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    draggable
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasSorted', value)
      }
    },
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Team.vue